import { TrainingSessionCompanyHistoryStudent } from './student/training-session-company-history-student';

export class TrainingSessionCompanyHistory {
    constructor(
        public sessionId?: number,
        public trainingTitle?: string,
        public startDate?: string,
        public students?: TrainingSessionCompanyHistoryStudent[]
    ) {}
}



// WEBPACK FOOTER //
// ./src/app/_services/session/company/history/training-session-history.model.ts